const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-P371EPT5EZ'

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

export function initializeAnalytics() {
  if (!measurementId || document.querySelector('script[data-facebul-ga]')) return
  window.dataLayer = window.dataLayer || []
  window.gtag = window.gtag || ((...args: unknown[]) => window.dataLayer?.push(args))
  window.gtag('js', new Date())
  window.gtag('config', measurementId)

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`
  script.dataset.facebulGa = 'true'
  document.head.append(script)
}

export function trackEvent(name: 'sign_up' | 'create_event') {
  window.gtag?.('event', name)
}
